'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._MainRegion = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withExternalPropsApp = require('../withExternalPropsApp');

var _withExternalPropsApp2 = _interopRequireDefault(_withExternalPropsApp);

var _MainRegionStyled = require('./styles/MainRegionStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  externalProps: _propTypes2.default.shape({
    fixed: _propTypes2.default.bool
  })
};

var defaultProps = {
  externalProps: {
    fixed: false
  }
};

var _MainRegion = exports._MainRegion = function _MainRegion(props) {
  return _react2.default.createElement(
    _MainRegionStyled.MainRegionStyled,
    { appFixed: props.externalProps.fixed },
    props.children
  );
};

_MainRegion.displayName = 'MainRegion';
exports.default = (0, _withExternalPropsApp2.default)(_MainRegion);


_MainRegion.propTypes = propTypes;
_MainRegion.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-app/dist/MainRegion/MainRegion.js
// module id = 532
// module chunks = 0